import { CDN_URL } from "@/Api";
import '@/style/dashboard.scss';
import ListProjects from "@/components/ListProjects";
import ListComponents from "@/components/ListComponents";
import ListUsers from "@/components/ListUsers";
import SidebarItem from "@/components/SidebarItem";
import { useUser } from "@/hooks/useUser";
import { useSearchParams } from "react-router-dom";

var Sidebar=()=>{
   var{logout}=useUser();

   return <>
      <div className="site">	
         <img src={`${CDN_URL}/assets/logo/LogoBH_Large.webp`} alt="Logo AREMA" />
      </div>
      <SidebarItem text="Proyectos" iconName="folder" to="/dashboard" search="" />
      <SidebarItem text="Componentes" iconName="database" to="/dashboard" search="?tab=components" />
      <SidebarItem text="Usuarios" iconName="users" to="/dashboard" search="?tab=users" />
      <div className="filler" />
		<SidebarItem text="Cerrar sesión" iconName="sign-out" extra onClick={logout} />
   </>
}

var Dashboard=()=>{
   var [searchParams] = useSearchParams();
   var tab = searchParams.get('tab') || 'projects';

   return <main style={{display:'grid', gridTemplateColumns:'repeat(6,1fr)', width:'100%', height:'100vh'}}>
      <div className="sidebar-container">
         <Sidebar />
      </div>
      <div style={{gridColumn:'span 5', overflowY: 'auto'}} className="drawer">
         {tab === 'projects' && <ListProjects />}
         {tab === 'components' && <ListComponents />}
         {tab === 'users' && <ListUsers />}
      </div>
   </main>
};

export default Dashboard;
